var map = {
	"./culik/logo.png": "7133",
	"./menanga/logo.png": "81ad",
	"./pikat/logo.png": "eab2",
	"./remun-surat/logo.png": "6b2a",
	"./sangsit/logo.png": "299f",
	"./sibetan/logo.png": "1e61"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0b05";